export default function R_Certificate() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Certificate Component</h1>
      <p>This is the R_Certificate tutorial section.</p>
    </div>
  );
}
